import React, { lazy, useEffect } from 'react'
import { useParams } from 'react-router-dom'
const FooterAdmin = lazy(() => import("../../components/Footers/FooterAdmin"))
const AdminNavbar = lazy(() => import("../../components/Navbars/AdminNavbar"))

const InvoiceDetail = () => {
  const params = useParams();
  const { '*': paramUrl } = params;
  console.log(paramUrl);

  useEffect(() => {
    (async () => {
      const response = await true;
      const { data, status } = response || {};
      if (status === 200 || status === 201) {
      } else if (status === 401) {
        localStorage?.setItem('route_to_go', paramUrl)
      }
    })()
  }, [])

  return (
    <div className="block w-full overflow-x-auto mt-6 bg-white rounded-xl" id='Itemslist'>
      Invoice Detail
    </div>
  )
}

export default InvoiceDetail